import React from 'react';
import { Notification } from '../types';
import { Bell, Mail, MessageSquare, AlertTriangle, Info, AlertCircle } from 'lucide-react';

interface NotificationPreviewProps {
  notification: Notification;
}

const NotificationPreview: React.FC<NotificationPreviewProps> = ({ notification }) => {
  const getPriorityIcon = () => {
    switch (notification.priority) {
      case 'high':
        return <AlertTriangle className="priority-icon high" size={20} />;
      case 'medium':
        return <AlertCircle className="priority-icon medium" size={20} />;
      case 'low':
        return <Info className="priority-icon low" size={20} />;
      default:
        return <Info className="priority-icon" size={20} />;
    }
  };

  const getChannelIcon = (channel: string) => {
    switch (channel) {
      case 'push':
        return <Bell size={16} />;
      case 'email':
        return <Mail size={16} />;
      case 'sms':
        return <MessageSquare size={16} />;
      default:
        return null;
    }
  };

  return (
    <div className="notification-preview-container">
      <h3>Notification Preview</h3>
      
      <div className={`notification-card priority-${notification.priority || 'medium'}`}>
        <div className="notification-header">
          <div className="notification-title">
            {getPriorityIcon()}
            <span>{notification.topic || 'No topic set'}</span>
          </div>
          <div className="notification-channels">
            {notification.channels?.map(channel => (
              <span key={channel} className="channel-badge" title={channel}>
                {getChannelIcon(channel)}
              </span>
            ))}
          </div>
        </div>
        
        <div className="notification-body">
          {notification.body || 'No message body set'}
        </div>
        
        <div className="notification-footer">
          <span className="priority-label">
            Priority: {notification.priority || 'medium'}
          </span>
        </div>
      </div>

      <div className="preview-devices">
        <div className="device-preview phone">
          <div className="device-header">Push Notification</div>
          <div className="device-notification">
            <div className="app-name">Pet Care App</div>
            <div className="notification-content">
              <strong>{notification.topic || 'Notification'}</strong>
              <p>{notification.body ? notification.body.substring(0, 100) + '...' : 'Message preview'}</p>
            </div>
            <div className="notification-time">now</div>
          </div>
        </div>

        {notification.channels?.includes('email') && (
          <div className="device-preview email">
            <div className="device-header">Email Preview</div>
            <div className="email-content">
              <div className="email-subject">
                <strong>Subject:</strong> {notification.topic || 'Pet Care Notification'}
              </div>
              <div className="email-body">
                <p>Dear Pet Owner,</p>
                <p>{notification.body || 'Your notification message will appear here.'}</p>
                <p>Best regards,<br />Pet Care Team</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPreview;